<xemex-page-header
  [title]="'sidebarMenu.dashboard' | translate"
  [subtitle]="('home.welcomeBack' | translate) + ', ' + userStore.user()?.fullName"
  titleSize="xl"
></xemex-page-header>

<xemex-page-body [scrollable]="true">
  <div class="flex flex-col gap-5">
    <xemex-dashboard-kpi-tiles [kpis]="kpis()"></xemex-dashboard-kpi-tiles>

    <div class="grid grid-cols-1 lg:grid-cols-2 gap-5 items-start">
      <div class="flex flex-col gap-5">
        <xemex-dashboard-devices-widget
          [segments]="deviceSegments()"
          [centerLabel]="devicesCenterLabel()"
          [installedTotal]="installedDevices()"
          (viewAll)="navigateTo(['/', APP_PATHS.Devices])"
          (segmentFilterClick)="onDeviceSegmentClick($event)"
        ></xemex-dashboard-devices-widget>

        <xemex-dashboard-recently-used-widget
          class="flex-1"
          [entries]="recentlyVisitedRows()"
          (entryClick)="navigateTo($event)"
        ></xemex-dashboard-recently-used-widget>
      </div>

      <div class="flex flex-col gap-5">
        <xemex-dashboard-alarms-widget
          [total]="visibleAlarmsTotal()"
          [priorityWedges]="priorityWedges()"
          [byType]="alarmsByType()"
          [maxTypeCount]="alarmTypeMaxCount()"
          (viewAll)="navigateTo(['/', APP_PATHS.Alarms])"
          (priorityFilterClick)="onPriorityFilterClick($event)"
          (typeFilterClick)="onAlarmTypeFilterClick($event)"
        ></xemex-dashboard-alarms-widget>

        <xemex-dashboard-new-alarms-widget
          class="flex-1"
          [alarms]="newAlarms()"
          (viewAll)="navigateTo(['/', APP_PATHS.Alarms])"
          (alarmClick)="onNewAlarmClick($event)"
        ></xemex-dashboard-new-alarms-widget>
      </div>
    </div>
  </div>
</xemex-page-body>
